/* eslint-disable import/order */
import React, { useEffect, useState } from 'react';
import { ProgressBar } from 'react-bootstrap';
import Countdown from 'react-countdown';
import { ImEarth } from 'react-icons/im';
import { SiTelegram, SiDiscord, SiTwitter, SiYoutube, SiLinkedin, SiMedium } from 'react-icons/si';
import UNKNOWN from 'assets/img/coins/unknown.png';
import EGLD from 'assets/img/coins/egld.png';
import USDC from 'assets/img/coins/usdc.png';
import moment from 'moment';
import { Link } from 'react-router-dom';
import './index.scss';

const IdoCard = (props: any) => {
    const { data } = props;

    useEffect(() => {
        try {
            setLogoUrl(`https://devnet-media.elrond.com/tokens/asset/${data.project_presale_token_identifier}/logo.png`);
        } catch (e) {}
    }, [data]);

    const [logoUrl, setLogoUrl] = useState<string>(UNKNOWN);
    const onErrorLogo = () => {
        setLogoUrl(UNKNOWN);
    };

    return (
        <>
            <div className='ido-box'>
                <Link className='ido-link' to={`/lauchpad/detail/${data.project_id}`} style={{ width: '100%', height: '100%' }} />
                <div className='d-flex justify-content-between align-items-center'>
                    <div className='d-flex flex-column'>
                        <span className='ido-box-token-id'>{data.project_presale_token_name}</span>
                        <span className='ido-box-title mt-2'>{data.project_presale_token_identifier}</span>
                    </div>
                    <div className='d-flex justify-content-end'>
                        <div>
                            <img src={logoUrl} alt={data.project_presale_token_identifier} width={'40px'} onError={onErrorLogo} />
                        </div>
                        <div style={{ marginLeft: '-16px', marginTop: '22px' }}>
                            <img style={{ boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.8)' }} src={data.project_fund_token_identifier == 'EGLD' ? EGLD : USDC} alt='logo' width={'20px'} />
                        </div>
                    </div>
                </div>

                <div className='ido-social-box mt-3'>
                    {
                        data.project_social_website !== '' && (
                            <a className='ido-social-link' href={data.project_social_website} rel='noreferrer' target='_blank'>
                                <ImEarth />
                            </a>
                        )
                    }
                    {
                        data.project_social_telegram !== '' && (
                            <a className='ido-social-link' href={data.project_social_telegram} rel='noreferrer' target='_blank'>
                                <SiTelegram />
                            </a>
                        )
                    }
                    {
                        data.project_social_discord !== '' && (
                            <a className='ido-social-link' href={data.project_social_discord} rel='noreferrer' target='_blank'>
                                <SiDiscord />
                            </a>
                        )
                    }
                    {
                        data.project_social_twitter !== '' && (
                            <a className='ido-social-link' href={data.project_social_twitter} rel='noreferrer' target='_blank'>
                                <SiTwitter />
                            </a>
                        )
                    }
                    {
                        data.project_social_youtube !== '' && (
                            <a className='ido-social-link' href={data.project_social_youtube} rel='noreferrer' target='_blank'>
                                <SiYoutube />
                            </a>
                        )
                    }
                    {
                        data.project_social_linkedin !== '' && (
                            <a className='ido-social-link' href={data.project_social_linkedin} rel='noreferrer' target='_blank'>
                                <SiLinkedin />
                            </a>
                        )
                    }
                    {
                        data.project_social_medium !== '' && (
                            <a className='ido-social-link' href={data.project_social_medium} rel='noreferrer' target='_blank'>
                                <SiMedium />
                            </a>
                        )
                    }
                </div>

                <div className='mt-3'>
                    <p className='ido-rate'>{`1 ${data.project_fund_token_identifier == 'EGLD' ? 'EGLD' : 'USDC'} = ${data?.project_presale_token_rate} ${data?.project_presale_token_name}`}</p>

                    <span>{'Progress (' + data.project_presale_percentage + '%)'}</span>
                    <ProgressBar className='mt-1' now={data.project_presale_percentage} />
                    <div className='d-flex justify-content-between mt-1'>
                        <span>{`0 ${data.project_fund_token_identifier == 'EGLD' ? 'EGLD' : 'USDC'}`}</span>
                        <span>{`${data.project_hard_cap} ${data.project_fund_token_identifier == 'EGLD' ? 'EGLD' : 'USDC'}`}</span>
                    </div>

                    {Number(data.project_total_fund_amount) >= Number(data.project_hard_cap) ? (
                        <div className='mt-4' style={{ fontSize: '15px' }}>
                            <div className='d-flex justify-content-center mt-1'>
                                <span>{'SOLD OUT'}</span>
                            </div>
                        </div>
                    ) : (
                        data.project_presale_start_time < Date.now() ? (
                            <div style={{ fontSize: '15px' }}>
                                {data.project_presale_end_time < Date.now() ? (
                                    <div className='d-flex justify-content-center mt-1'>
                                        <span>{'ENDED'}</span>
                                    </div>
                                ) : (
                                    <div className='d-flex justify-content-between mt-1'>
                                        <span>{'END IN: '}</span>
                                        <span>{moment(data.project_presale_end_time).format('DD MMM YYYY hh:mm a')}</span>
                                    </div>
                                )}
                            </div>
                        ) : (
                            <div className='mt-2' style={{ fontSize: '15px' }}>
                                <div className='d-flex justify-content-between mt-1'>
                                    <span>{'START IN:'}</span>
                                    <span>{moment(data.project_presale_start_time).format('DD MMM YYYY hh:mm a')}</span>
                                </div>
                            </div>
                        )
                    )}
                </div>
                {Number(data.project_total_fund_amount) >= Number(data.project_hard_cap) ? (
                    <></>
                ) : (
                    data.project_presale_start_time < Date.now() ? (
                        <div className='d-flex justify-content-center mt-2'>
                            <Countdown className='ido-box-countdown' date={data.project_presale_end_time} autoStart />
                        </div>
                    ) : (
                        <div className='d-flex justify-content-center mt-2'>
                            <Countdown className='ido-box-countdown' date={data.project_presale_start_time} autoStart />
                        </div>
                    )
                )}
            </div>
        </>
    );
};

export default IdoCard;